import { render, staticRenderFns } from "./ChamberInvitation.vue?vue&type=template&id=2321ce32&scoped=true&"
import script from "./ChamberInvitation.vue?vue&type=script&lang=js&"
export * from "./ChamberInvitation.vue?vue&type=script&lang=js&"
import style0 from "./ChamberInvitation.vue?vue&type=style&index=0&id=2321ce32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2321ce32",
  null
  
)

export default component.exports